import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface InvalidEmailsErrorDialogData {
	title: string;
	message: string;
	additionalMessage?: string;
	closingMessage?: string;
	emails?: string[];
	userNames?: string[];
	dialogTitleId?: string;
}

@Component({
	selector: 'invalid-emails-error-dialog',
	templateUrl: './invalid-emails-error-dialog.component.html',
	styleUrls: ['./invalid-emails-error-dialog.component.scss'],
	standalone: false
})
export class InvalidEmailsErrorDialogComponent {
	// A small helper to open the dialog with all the correct typing
	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<InvalidEmailsErrorDialogData>
	): MatDialogRef<InvalidEmailsErrorDialogComponent, boolean> {
		const dialogTitleId = config?.data?.dialogTitleId ?? InvalidEmailsErrorDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, InvalidEmailsErrorDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `invalid-emails-error-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public constructor (
		public dialogRef: MatDialogRef<InvalidEmailsErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: InvalidEmailsErrorDialogData
	) {
		this.data.dialogTitleId ??= InvalidEmailsErrorDialogComponent.getDialogTitleId();
	}

	public close () {
		this.dialogRef.close();
	}
}
